export const iconFontAwesomeBuildingsHotel = (
	<i className="fa-solid fa-hotel"></i>
);
